// MF-67 — Table look for the journal lists. The app theme uses very tight cells (0.125rem) and a
// strong blue zebra; Journal lists get breathing room, a quiet hover and a card-like container instead.
// Scoped here (not in the global theme) so the rest of Maestro is untouched.

export const tableCardStyle = {
  backgroundColor: '#fff',
  border: '1px solid rgb(226, 232, 240)',
  borderRadius: 12,
  overflow: 'hidden'
}

export const journalTableSx = {
  '& .MuiTableCell-root': {
    padding: '8px 16px',
    borderBottom: '1px solid rgb(241, 245, 249)',
    fontSize: 13,
    color: 'rgb(30, 41, 59)'
  },
  '& .MuiTableCell-head': {
    padding: '8px 16px',
    backgroundColor: 'rgb(248, 250, 252)',
    borderBottom: '1px solid rgb(226, 232, 240)',
    color: 'rgb(71, 85, 105)',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.04em'
  },
  '& .MuiTableRow-root:nth-of-type(even)': { backgroundColor: 'transparent' },
  '& .MuiTableBody-root .MuiTableRow-root:hover': { backgroundColor: 'rgb(248, 250, 252)' },
  '& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root': { borderBottom: 'none' }
}
